<template>
  <msgDialog title="患儿注册"  width="600px" @close="closeDetail" :visible.sync="showDialog" >
      <el-form v-if="newStep == 1" style="width: 100%" :inline="true" :rules="rules" :model="newForm" ref="ruleForm">
        <el-row >
          <el-col :md="12">
            <el-form-item label="患儿姓名" prop="childName">
              <el-input v-model="newForm.childName" class="form-value" placeholder="患儿姓名" size="small" @focus="btnChangeEnable=false"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item label="性别" prop="sex" @change=" btnChangeEnable=false ">
              <el-radio-group v-model="newForm.sex" class="my-radio">
                <!-- <el-radio :label="item.valueCode" v-for="item in genderData" :key="item.id" size="small">
                  {{item.valueName}}
                </el-radio> -->
                <el-radio label="1">男</el-radio>
                <el-radio label="0">女</el-radio>
                <el-radio label="3">未知</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="身份证" prop="hasIdNumber">
              <div>
                <el-radio-group v-model="newForm.hasIdNumber" @change="changehasId ; btnChangeEnable=false" size="small">
                  <el-radio label="1">有</el-radio>
                  <el-radio label="0">无</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="newForm.hasIdNumber == 1 || newForm.hasIdNumber == null">
            <el-form-item label="身份证号" prop="idNumber">
              <el-input v-model="newForm.idNumber" placeholder="身份证号" size="small" @change="idNumberChange" @focus="btnChangeEnable=false"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-else>
            <el-form-item label="身份证号">
              <el-input size="small" disabled value="-"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="出生日期" prop="birthday">
              <el-date-picker v-model="newForm.birthday" type="date" placeholder="选择日期" :disabled="newForm.hasIdNumber == 1"
                              value-format="timestamp" format="yyyy-MM-dd" size="small" :picker-options="pickerOptions" @change="btnChangeEnable=false">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="户口所在地" prop="locationArr">
              <LocationCascader v-model="newForm.locationArr" @change="handleChange"></LocationCascader>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-form v-if="newStep == 2"  style="width: 80%" :inline="true" :rules="rules" :model="newForm" class="demo-form-inline" ref="ruleForm1">
        <el-row>
          <el-col :span="24">
            <el-form-item label="救助医院" prop="hospitalId">
              <HospitalSelect v-model="newForm.hospitalId" @change="hospitalChange"  :disabled="isHospitalRole"></HospitalSelect>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="病种" prop="diseasesIdList">
              <DiseaseCascader
                v-model="newForm.diseasesIdList"
                :hospitalId="newForm.hospitalId"
                placeholder="点击选择病种或在此输入进行检索"
                :multiple="true"
                @change="changeDisease">
              </DiseaseCascader>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row v-if="initialProject == 'AY1001'">
          <el-col :span="24">
            <el-form-item label="病种类型" prop="diseasesType">
              <DictionarySelect v-model="newForm.diseasesType"  :lazy="true" tableCode="DISEASES_TYPE">
              </DictionarySelect>
            </el-form-item>
          </el-col>
        </el-row> -->

        <el-row>
          <el-col :span="24" >
            <el-form-item label="单次/分期" prop="quotaType">
              <el-radio-group v-model="newForm.quotaType" :disabled="disabledQuotaType || isAllowStages == 0" @change="changePeriod" size="small">
                <el-radio :label="0">单次</el-radio>
                <el-radio :label="1">分期</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="期数" style="position: relative">
              <el-input v-if="isAngleProject" value="-" disabled size="small"></el-input>
              <el-input v-else v-model="newForm.totalStages" disabled size="small"></el-input>
              <div v-if="!isAngleProject&&newForm.quotaType==1" class="error">
                <img src="/static/err-icon.png" alt="">
                <span>如需修改期数，请联系项目人员！</span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="住院号" prop="inHospitalNo" :rules="[{ required: currentHospital.isAuto == 1, message: '请输入住院号', trigger: 'change' }]">
              <el-input v-model="newForm.inHospitalNo" placeholder="住院号" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
	      <el-row v-if="currentHospital.isShowInHospitalTime == 1">
		      <el-col :span="24">
			      <el-form-item label="入院时间" prop="inHospitalTime" :rules="[{ required: currentHospital.isAuto == 1, message: '请输入入院时间', trigger: 'change' }]">
				      <el-date-picker
						      v-model="newForm.inHospitalTime"
						      align="right"
						      type="date"
						      size="small"
						      placeholder="选择时间"
						      value-format="timestamp"
						      :picker-options="pickerOptions">
				      </el-date-picker>
			      </el-form-item>
		      </el-col>
	      </el-row>
        <el-row v-if="currentHospital.isShowInHospitalNumber	== 1">
          <el-col :span="24">
            <el-form-item label="住院流水号" prop="inHospitalSerialNo" :rules="[{required: currentHospital.isShowInHospitalNumber == 1, message: '请输入住院流水号', trigger: 'blur' }]">
              <el-input v-model="newForm.inHospitalSerialNo" placeholder="住院流水号"  size="small" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="登录手机号" prop="loginAccount">
              <el-input v-model="newForm.loginAccount" placeholder="登录手机号" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="验证码" class="getMsg-box" prop="captcha">
              <MsgCodeInput  @msgCodeValue="msgCodeValue" :tel="newForm.loginAccount"></MsgCodeInput>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="登录方式" prop="loginChannel">
              <el-radio-group v-model="newForm.loginChannel" :disabled="true" size="small"
                              @change="changeLoginWay">
                <el-radio :label="item.valueCode" v-for="item in loginWayData" :key="item.id">{{item.valueName}}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <!--        <ChapterHead v-if="newForm.loginChannel == 2" :level="2" :showWarning="true">-->
        <!--          <span>支付宝相关信息</span>-->
        <!--          -->
        <!--        </ChapterHead>-->
        <div v-if="isWelfareBabyType" style="height: 60px;line-height: 60px;border-top: #dc243e 1px solid;color: #bfbfbf" >所选病种中包含公益宝贝病种，请填写支付宝相关信息。</div>
        <el-row v-if="isWelfareBabyType">
          <el-col :span="24">
            <el-form-item label="支付宝姓名" prop="loginUserName" >
              <el-input placeholder="请输入支付宝姓名" v-model="newForm.loginUserName" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="支付宝身份证" prop="loginIdNumber">
              <el-input placeholder="请输入支付宝身份证" v-model="newForm.loginIdNumber" size="small"></el-input>
            </el-form-item>
          </el-col>
<!--          <el-col :span="24">
            <el-form-item label="支付宝账号" prop="loginUserId">
              <el-input placeholder="请输入支付宝账号" v-model="newForm.loginUserId" size="small"></el-input>
            </el-form-item>
          </el-col>-->
          <el-col :span="24">
            <el-form-item label="与患儿关系" prop="loginRelation">
              <DictionarySelect
                v-model="newForm.loginRelation"
                tableCode="CHILD_RELATION"
                :lazy="true">
              </DictionarySelect>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    <!--    beforCommitDialog-->
<!--    <msgDialog :showErrorIcon="true"  title="提示" width="30%" @close="beforCommitDialog = false" :visible.sync="beforCommitDialog">-->
<!--      <span>是否确认提交本次患儿注册申请</span>-->
<!--      <div slot="footer" >-->
<!--        <el-button  @click="beforCommitDialog = false;commited = false">返回上一级</el-button>-->
<!--        <el-button type="primary"  @click="beforCommit" >确 定</el-button>-->
<!--      </div>-->
<!--    </msgDialog>-->
    <msgDialog :showErrorIcon="true" title="提示"  width="630px" @close="beforCommitDialog = false" :visible.sync="beforCommitDialog">
      <table border="0" cellspacing="0" cellpadding="0" style="margin: 0px auto 20px; width: 530px">
        <tr>
          <td style="height: 64px;">
            <div style="height: 64px; display: flex; align-items: center;">
              <span style="font-size: 16px;">该申请登录方式为：</span>
              <img v-if="isWelfareBabyType" style="width: 32px;" src="/static/alipay.png" />
              <img v-else style="width: 32px;" src="/static/wx.png" />
              <span v-if="isWelfareBabyType" style="color: #226BF3; font-size: 16px; margin-left: 10px;"> 支付宝</span>
              <span v-else style="color: #2FCC69; font-size: 16px; margin-left: 10px;"> 微信</span>
            </div>
          </td>
          <td rowspan="2" style="width: 160px; text-align: center;">
            <img v-if="isWelfareBabyType" style="width: 120px;" src="/static/msg/alipay.png" />
            <img v-else style="width: 120px;" src="/static/msg/wexin.jpg" />
          </td>
        </tr>
        <tr>
          <td>
            <span style="font-size: 16px">请扫码或登录“爱佑救助通道”小程序 </span>
          </td>
        </tr>
      </table>

      <div slot="footer" >
        <el-button :loading="loading" @click="beforCommitDialog = false;commited = false">返回上一级</el-button>
        <el-button :loading="loading" type="primary" @click="beforCommit">确 定</el-button>
      </div>
    </msgDialog>
    <msgDialog :showErrorIcon="true" title="提示" @close="showMsg2 = false" :visible.sync="showMsg2">
      <span style="font-weight: bold;font-size: 16px">患儿已在其他医院注册，请联系爱佑基金会管理人员。</span>
      <div slot="footer" >
        <el-button  @click="showMsg2 = false " >关 闭</el-button>
      </div>
    </msgDialog>
    <msgDialog :showErrorIcon="true" title="提示" @close="showMsg6 = false" :visible.sync="showMsg6">
      <span style="font-weight: bold;font-size: 16px">患儿已存在，请前往<span v-if="reqModeInfo==1">注册</span><span v-else-if="reqModeInfo==2">代申请</span>页面继续完善患儿信息。</span>
      <div slot="footer" >
        <el-button  @click="showMsg6 = false " >关 闭</el-button>
      </div>
    </msgDialog>
    <msgDialog :showErrorIcon="true"  title="提示" @close="showMsg1 = false" :visible.sync="showMsg1">
      <span>患儿已存在，可在 <span
        style="font-weight: bold">患儿管理-新增病种</span>后进行救助申请！</span>
      <span class="info" @click="toRquersDetail">进入患儿详细信息页面》》</span>
      <div slot="footer" >
        <el-button  @click="showMsg1 = false " >关 闭</el-button>
      </div>
    </msgDialog>
    <msgDialog :showErrorIcon="true" title="提示"  @close="showMsg4 = false" :visible.sync="showMsg4">
      <span style="font-weight: bold;font-size: 16px">患儿基本信息重复！<br>存在基础信息重复患儿，请联系项目经理。</span>
      <div slot="footer" >
        <el-button  type="primary"  @click="continueAdd">确 定</el-button>
      </div>
    </msgDialog>
    <msgDialog :showErrorIcon="true" title="提示"  @close="showMsg5 = false" :visible.sync="showMsg5">
      <span style="font-weight: bold;font-size: 16px">患儿基本信息重复！<br>当前患儿基本信息重复
        <span style="color: #E8556F">疑似存在相似患儿且未审核</span>
        ，请联系项目经理。</span>
      <div slot="footer" >
        <el-button  type="priFmary"  @click="closeDialog">确 定</el-button>
      </div>
    </msgDialog>
    <div slot="footer" class="dialog-footer" style="text-align: center;height: 60px">
      <el-button type="primary" icon="el-icon-close" plain style="background-color: #FFFFFF;color: #E8556F" @click="closeDetail">取消</el-button>
      <!-- <el-button :loading="loading" v-if="newStep==2" type="primary" @click="saveRequest">暂存</el-button> -->
      <el-button :loading="loading" :disabled="btnChangeEnable" :icon="newStep == 1 ? 'el-icon-arrow-right' : 'el-icon-circle-check'" type="primary" style="margin-left: 20px" @click="nextStep">{{ newStep==1?'下一步':'提交' }}</el-button>
    </div>
    <!--    </el-dialog>-->
  </msgDialog>

</template>

<script>
  import ChapterHead from "@/components/business/ChapterHead";
  import LocationCascader from '@/components/business/LocationCascader'
  import HospitalSelect from "@/components/business/HospitalSelect";
  import DiseaseCascader from "@/components/business/DiseaseCascader"
  import DictionarySelect from "@/components/business/DictionarySelect"
  import MsgCodeInput from "@/components/business/MsgCodeInput";
  import msgDialog from "@/components/business/msgDialog";
  import {
    isCaptchaMatchApi,
    getAYDictByTableCodeApi,
    getCMDictByTableCodeApi,
    checkChildExistsApi,
    sbumitRequestApi,
    saveRequestApi,
    uniqueInHospitalNo,
    addSimilarChildBaseInfo,
    checkSimilarChildBaseInfo,
    uniqueInHospitalSerialNo
  } from "@/util/api.js";
import { parseTime } from '../../../util/common';
  export default {
    name: "rNew",
    props: {
      detailDialog: false,
      queryList: {
        type: Function,
        default: null
      }
    },
    watch: {
      detailDialog() {
        this.showDialog = this.detailDialog;
      },
    },
    created() {
      this.getGender() //查看性别字典
    },
    components: {
      ChapterHead,
      LocationCascader,
      HospitalSelect,
      DiseaseCascader,
      DictionarySelect,
      msgDialog,
      MsgCodeInput,
    },
    data() {
      var idCard = (rule, value, callback) => {
        if (!value) {
          return callback(new Error("请输入身份证号"));
        } else {
          var p =
            /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
          if (!p.test(value)) {
            callback("身份证格式不正确");
          }
        }
        callback();
      };
      var phoneVt = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('请输入手机号'));
        } else {
          var p = /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
          if (!p.test(value)) {
            callback('手机号格式不正确')
          }
          callback()
        }
      };
      let isHospitalRole = this.isHospital();
      return {
        isHospitalRole: isHospitalRole,
        currentHospital: {},
        loading: false,
        initialProject: null,
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now() - 8.64e6;
          }
        },
        isAllowStages:0,
        newForm: {
          loading: false,
          helpReqId: null,
          totalStages: null,
          childName: null,
          sex: null,
          hasIdNumber: null,
          idNumber: null,
          birthday: null,
          province: null, //所在省
          city: null, //所在市
          county: null, //所在区县
          hospitalId: null, //救助医院id
          diseasesList: [],
          loginAccount: null, //登录手机号，
          period: null, //是否分期
          diseasesType: null, //病种类型
          loginChannel: null, //登陆方式
          guardPhone: null,
          guardIdNumber: null,
          guardWechat: null,
          loginUserId: null,
          loginUserName: null,
          quotaType: null,
          loginIdNumber: null,
          captcha: null, //验证码
	        inHospitalTime: null
        },
        showDialog: this.detailDialog,
        newStep: 1, // 添加患儿 1第一步 2第二步
        showMsg1: false,
        commited:false,
        showMsg2: false,
        showMsg3: false,
        showMsg4: false,
        showMsg5: false,
        showMsg6:false,
        beforCommitDialog:false,
        lastHelpId:'',
        selectedOptions: [],
        illnessOptions: [],
        hospitalOptions: [],
        rules: {
          childName: [{
            required: true,
            message: '请输入患儿姓名',
            trigger: 'blur'
          }],
          sex: [{
            required: true,
            message: '请选择性别',
            trigger: 'change'
          }],
          hasIdNumber: [{
            required: true,
            message: '是否持有身份证',
            trigger: 'change'
          }],
          idNumber: [{
            required: true,
            message: '请输入身份证号',
            trigger: 'blur'
          }, {
            validator: idCard,
            trigger: 'blur'
          }],
          locationArr: [{
            required: true,
            message: '请选择户口所在地',
            trigger: 'change'
          }],
          birthday: [{
            required: true,
            message: '请选择出生日期',
            trigger: 'blur'
          }],
          hospitalId: [{
            required: true,
            message: '请选择救助医院',
            trigger: 'blur'
          }],
          diseasesIdList: [{
            required: true,
            message: '请选择病种',
            trigger: 'change'
          }],
          quotaType: [{
            required: true,
            message: '请选择单次/分期',
            trigger: 'change'
          }],
          // diseasesType: [{
          //   required: true,
          //   message: '请选择病种类型',
          //   trigger: 'change'
          // }],
          loginAccount: [{
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          }, {
            validator: phoneVt,
            trigger: 'blur'
          }],
          captcha: [{
            required: true,
            message: '请输入验证码',
            trigger: 'blur'
          }],
          loginChannel: [{
            required: true,
            message: '请选择登录方式',
            trigger: 'change'
          }],
          guardPhone: [{
            required: true,
            message: '请输入监护人联系电话',
            trigger: 'blur'
          }, {
            validator: phoneVt,
            trigger: 'blur'
          }],
          guardIdNumber: [{
            required: true,
            message: '请输入监护人身份证号',
            trigger: 'blur'
          }, {
            validator: idCard,
            trigger: 'blur'
          }],
          guardWechat: [{
            required: true,
            message: '请输入监护人微信号',
            trigger: 'blur'
          }],
          loginUserId: [{
            required: true,
            message: '请输入支付宝账号',
            trigger: 'blur'
          }],
          loginUserName: [{
            required: true,
            message: '请输入支付宝姓名',
            trigger: 'blur'
          }],
          loginRelation: [{ required: true, message: "请选择与患儿关系", trigger: "change" }],
          loginIdNumber: [{
            required: true,
            message: '请输入支付宝身份证号',
            trigger: 'blur'
          }, {
            validator: idCard,
            trigger: 'blur'
          }],
        },
        lazy: {
          lazy: true,
          lazyLoad: this.lazyLoad
        },
        valueParentId: '',
        diseasesText:'',
        level: 0,
        codeFlag: false,

        codeText: '获取验证码', //发送验证码文字
        countDown: 60, //多少秒后可重新发送
        diseaseOptions: [], //病种数据
        isWelfareBabyType: 0, // 是否是公益宝贝
        isAngleProject: false,
        disabledQuotaType: false,
        genderData: [], //性别字典数据
        loginWayData: [], //登陆方式字典数据
        locationArr: [], //选中户口所在地信息
        diseaseData: [], //选中的病种信息
        btnChangeEnable:false,  //下一步按钮禁用
        childExists:{},
        reqModeInfo:""
      }
    },
    methods: {
      closeMsg4(){
        this.showMsg4 = false
      },
      msgCodeValue(text){
        this.newForm.captcha = text
      },
      // // 校验验证码是否匹配
      isCaptchaMatch() {
        this.loading = true;
        let params = {
          phone: this.newForm.loginAccount,
          captcha: this.newForm.captcha
        }
        isCaptchaMatchApi(params).then(res => {
          this.loading = false;
          if (res.msgCode == 200) {
            if(res.success){
              this.beforCommitDialog = true
              this.diseasesText = ''
              this.newForm.diseasesList.forEach((item,index)=>{
                if(index==this.newForm.diseasesList.length){
                  this.diseasesText +=item.diseasesName
                }else{
                  this.diseasesText +=item.diseasesName+','
                }
              })

            }else{
              this.$message.error('验证码错误请重新输入')
              return
            }

          } else {
            this.$message.error('验证码验证失败')
          }
        }).catch()
      },
      hospitalChange(id, obj){
        this.isAllowStages = obj.isAllowStages
        if (this.newForm.diseasesIdList && this.newForm.diseasesIdList.length > 0) {
          this.newForm.diseasesIdList = null;
          this.changeDisease(null, false, false, null);
        }
        this.currentHospital = obj;
        // if (this.isAllowStages == 0) {
        // this.$set(this.newForm, 'quotaType', 0);
        // }
      },
      // // 改变登录方式
      changeLoginWay(e) {
        if (e == 1) {
          this.newForm.loginUserId = null
          this.newForm.loginUserName = null
          this.newForm.loginIdNumber = null
        } else {
          this.newForm.guardWechat = null
        }
      },
      // // 改变是否有身份证号
      changehasId(e) {
        if(this.newForm.hasIdNumber==1){
          this.newForm.birthday=""
        }else{
          this.newForm.idNumber=""
        }
        if (!e) this.newForm.idNumber = ''
      },
      // // 暂存患儿注册
      saveRequest() {
        this.loading = true;
        saveRequestApi(this.newForm).then(res => {
          this.loading = false;
          if (res.msgCode == 200) {
            this.newForm.locationArr = this.locationArr
            this.newForm.diseaseData = this.diseaseData
            this.newForm.isWelfareBabyType = this.isWelfareBabyType
            this.$emit('changeChild')
            this.closeDetail()
          } else {
            this.$message.error(res.msg)
          }
        }).catch()
      },
      // // 登录方式字典
      loginWay() {
        let params = {
          tableCode: "LOGIN_CHANNEL",
        }
        getCMDictByTableCodeApi(params).then(res => {
          if (res.msgCode == 200) {
            this.loginWayData = res.responseData
          } else {
            this.$message.error(res.msg)
          }
        }).catch()
      },
      // 获取性别
      getGender() {
        // let params = {
        //   tableCode: "C00001",
        // }
        // getAYDictByTableCodeApi(params).then(res => {
        //   if (res.msgCode == 200) {
        //     this.genderData = res.responseData
        //   } else {
        //     this.$message.error(res.msg)
        //   }
        // })
      },
      idNumberChange () {
        if (this.newForm.idNumber && this.newForm.idNumber.length > 14) {
          let year = this.newForm.idNumber.substring(6, 10);
          let month = this.newForm.idNumber.substring(10, 12);
          let day = this.newForm.idNumber.substring(12, 14);
          this.newForm.birthday = new Date(year, parseInt(month) - 1, day);
        } else {
          this.newForm.birthday = null;
        }
      },
      // 选择分期方式
      changePeriod(e) {
        this.newForm.totalStages = this.newForm.quotaType == 1 ? 3 : 1;
        this.$forceUpdate()
      },
      // 选择病种
      changeDisease(ids, isWelfareBaby, isAngleProject, initialProject) {
        if (ids && ids.length > 0) {
          this.isWelfareBabyType = isWelfareBaby ? 1 : 0;
          this.isAngleProject = isAngleProject;
          this.initialProject = initialProject;
          this.disabledQuotaType = this.isAllowStages == 0 || initialProject != 'AY1001';
          if (this.disabledQuotaType) {
            this.$set(this.newForm, 'quotaType', this.isAngleProject ? 1 : 0);
            this.changePeriod(this.newForm.quotaType);
          }
        } else {
          this.$set(this.newForm, 'quotaType', null);
          this.newForm.totalStages = null;
          this.newForm.curStages = null;
          this.isWelfareBabyType = null;
          this.isAngleProject = null;
          this.initialProject = null;
        }
        if (this.isWelfareBabyType) {
          this.newForm.loginChannel = '2';
        } else {
          this.newForm.loginChannel = '1'
        }

        if (ids && ids.length > 0){
          this.newForm.diseasesList = ids.map(d => {
            return {
              diseasesId: d
            }
          })
        } else {
          this.newForm.diseasesList = null;
        }
      return;

      },
      //   // 选择出生日期
      changeBirthday(e) {
        this.newForm.birthday = e
      },
      closeDetail() {
        this.newStep = 1
        this.$emit("update:detailDialog", false);
        this.locationArr = [] //选中户口所在地信息
        this.diseaseData = [] //选中的病种信息
        for (var key in this.newForm) {
          this.newForm[key] = ''
        }
        //刷新页面
        this.queryList();
      },
      handleChange(e) {
        this.locationArr = e
        this.newForm.province = e[0]
        this.newForm.city = e[1]
        this.newForm.county = e[2]
        this.btnChangeEnable=false;
      },
      toRquersDetail(){
        this.closeDetail();
        this.$router.push({path:'/child/detail',query:{helpId:this.lastHelpId}})
      },
      nextStep() {
        let _this = this
        if (this.newStep == 1) {
          this.$refs['ruleForm'].validate((valid) => {
            if (valid) {
              if(this.newForm.hasIdNumber==1){
                if (this.newForm.idNumber && this.newForm.idNumber.length != 18) {
                  this.$message.error('身份证格式不正确');
                  return false;
                } else if (this.newForm.idNumber && this.newForm.idNumber.substring(6, 14) != this.parseTime(this.newForm.birthday, '{y}{m}{d}')) {
                  this.$message.error('出生日期与身份证号码中的日期不符');
                  return false;
                }
              }

              this.loading = true;
              let params = {
                childName: _this.newForm.childName,
                sex: _this.newForm.sex,
                hasIdNumber: _this.newForm.hasIdNumber,
                idNumber: _this.newForm.idNumber,
                birthday: parseTime(_this.newForm.birthday, '{y}-{m}-{d}'),
                province: _this.newForm.province, //所在省
                city: _this.newForm.city, //所在市
                county: _this.newForm.county, //所在区县
                hospitalId:_this.newForm.hospitalId

              }
              if(params.hasIdNumber == 0){
                params.idNumber=''
              }
              //有身份证验证患儿是否已存在
              checkChildExistsApi(params).then(res => {
                if (res.msgCode == 200){
                  this.loading = false;
                  this.childExists=res.responseData;
                  if ( this.childExists.childExistsCode==1){    //如果患儿已存在，提示新增病种（有身份证）
                    _this.showMsg1 = true
                    this.lastHelpId = this.childExists.lastHelpId
                  }else {
                    //验证相似患儿是否是未审核状态
                    checkSimilarChildBaseInfo({
                      ...this.newForm,
                      birthday: parseTime(this.newForm.birthday, '{y}-{m}-{d}')
                    }).then(res => {
                      this.loading = false;
                      if (res.msgCode == 200 && res.msg == '验证失败') {
                        //提示当前患儿基本信息重复疑似存在相似患儿且未审核，请联系联系项目经理
                        this.showMsg5=true;
                      }else {
                            //验证是否存在相似患儿
                            if (this.childExists.childExistsCode == 0) {
                              _this.newStep = 2
                              _this.loginWay()
                            } else if (this.childExists.childExistsCode == 2) {
                              _this.showMsg2 = true
                            } else if (this.childExists.childExistsCode == 3) {
                              _this.showMsg4 = true
                            }else if(this.childExists.childExistsCode == 6){
                              _this.showMsg6 = true
                              this.reqModeInfo=this.childExists.childReqmode;
                            }
                      }
                    })
                  }
                }else{
                  this.$message.error(res.msg,{ duration: 10000 });
                  return;
                }
              })

            }
          })
        } else {
          this.$refs['ruleForm1'].validate(async (valid) => {
            if (valid) {
              //判断如果是自动对接，并且显示住院流水号，需要校验流水号
              if (this.currentHospital.isShowInHospitalNumber == 1 && this.currentHospital.isAuto) {
                try {
                  await this.uniqueInHospitalSerialNo();
                } catch (error) {
                  return; // 校验失败时终止流程
                }
              }
              if (this.currentHospital.isAuto == 1 && this.newForm.hospitalId) {
                if (!this.newForm.inHospitalNo) {
                  this.$message.error('住院号不能为空！');
                  return;
                }
                if (!this.newForm.inHospitalTime) {
                  this.$message.error('入院时间不能为空！');
                  return;
                }
                uniqueInHospitalNo({  //校验住院号唯一
                  hospitalId: this.newForm.hospitalId,
                  inHospitalNo: this.newForm.inHospitalNo,
                  inHospitalTime: this.newForm.inHospitalTime,
                }).then(res => {
                  if (res.msgCode == 200) {
                    if (res.responseData == 1) {
                      this.isCaptchaMatch();
                    } else {
                      this.$message.error('住院号已存在！')
                    }
                  } else {
                    this.$message.error(res.msg);
                  }
                });
              } else {
                this.isCaptchaMatch();
              }

            }
          })
        }
      },
      beforCommit(){

        this.sbumitRequest()
      },
      // // 注册账号
      sbumitRequest() {
        if(this.commited)return
        this.commited = true
        this.loading = true;
        this.nextStep.captcha = null
        sbumitRequestApi({
          ...this.newForm,
          birthday: parseTime(this.newForm.birthday, '{y}-{m}-{d}')
        }).then(res => {
          this.loading = false;
          if (res.msgCode == 200) {
            this.$message({
              duration: 5000,
              message: res.msg,
              type: 'success'
            })
            this.closeDetail()
            this.$emit('changeChild')

          } else {

            this.$message.error(res.msg)
          }
          setTimeout(()=>{
            this.commited = false
          },5000)
        }).catch(
          setTimeout(()=>{
            this.commited = false
          },5000)
        )
      },

      continueAdd() {
        this.addSimilarChildBaseInfo();
      },
      addSimilarChildBaseInfo(){
        addSimilarChildBaseInfo({
          ...this.newForm,
          birthday: parseTime(this.newForm.birthday, '{y}-{m}-{d}')
        }).then(res => {
          this.loading = false;
          if (res.msgCode == 200) {
            this.newStep = 1;
            this.btnChangeEnable=true;
            this.showMsg4 = false
          }
        })

      },
      closeDialog(){
        this.newStep = 1;
        //this.btnChangeEnable=true;
        this.showMsg5 = false
      },
      /**
       * 校验住院流水号
       */
      uniqueInHospitalSerialNo() {
        return new Promise((resolve, reject) => {
          if (!this.newForm.inHospitalSerialNo) {
            this.$message.error('住院流水号不能为空！');
            return reject();
          }

          uniqueInHospitalSerialNo({
            hospitalId: this.currentHospital.hospitalId,
            childName: this.newForm.childName,
            inHospitalTime: this.newForm.inHospitalTime,
            inHospitalSerialNo: this.newForm.inHospitalSerialNo,
          }).then(result => {
            if (result.msgCode != 200 || !result.responseData) {
              this.$message.error('住院流水号校验失败！');
              reject();
            } else {
              resolve();
            }
          });
        });
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import "src/common/form";
  @import "src/common/common";
  /deep/ .el-dialog__header{
    padding-left: 16px;
    padding-bottom: 16px;
    .el-dialog__headerbtn .el-dialog__close{
      color: #909399;
      font-size: 30px;
      cursor: pointer;
    }
    .el-dialog__headerbtn .el-dialog__close:hover{
      color: #E8556F;
    }
    .el-dialog__title{
      font-size: 22px;
    }
  }
  .codeMsg {
    width: 4vw;
    height: 32px;
    position: absolute;
    top: 5px;
    right: 0px;
    font-size: 12px;
    font-family: PingFangSC;
    font-weight: bold;
    color: #FFFFFF;
    background: #E8556F;
    border-radius: 0.208vw;
    line-height: 32px;
    text-align: center;
  }
  .info{
    width: 100%;
    color: #E8556F;
    text-align: center;
    display: block;
    margin-top: 20px;
    cursor: pointer;
  }
  .my-radio /deep/ .el-radio{
      margin-right: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/child/register/ChildAdd.vue